/**
 * OrbDocTutorialsBeginnerCompleteOrbitalAROrbDocTutorialsBeginnerCompleteOrbitalARPage
 *
 * Page component for OrbDocTutorialsBeginnerCompleteOrbitalAROrbDocTutorialsBeginnerCompleteOrbitalARPage
 * Path: /ar/docs/tutorials/beginner/complete-orbital
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocTutorialsBeginnerCompleteOrbitalARDocScreenView as __OrbDocTutorialsBeginnerCompleteOrbitalARDocScreenView } from '@/components/traits/OrbDocTutorialsBeginnerCompleteOrbitalARDocScreenView';
import { OrbDocTutorialsBeginnerCompleteOrbitalARDocAnalyticsView as __OrbDocTutorialsBeginnerCompleteOrbitalARDocAnalyticsView } from '@/components/traits/OrbDocTutorialsBeginnerCompleteOrbitalARDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocTutorialsBeginnerCompleteOrbitalAROrbDocTutorialsBeginnerCompleteOrbitalARPageProps {
  // Add any page-level props here
}

export function OrbDocTutorialsBeginnerCompleteOrbitalAROrbDocTutorialsBeginnerCompleteOrbitalARPage(_props: OrbDocTutorialsBeginnerCompleteOrbitalAROrbDocTutorialsBeginnerCompleteOrbitalARPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"ابنِ مداريًّا كاملًا","description":"ابنِ مسار موافقة على المصروفات من حالة واحدة إلى أربع، مع شرط يفرض قاعدة إنفاق.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/tutorials/beginner/complete-orbital"},{"locale":"ar","path":"/ar/docs/tutorials/beginner/complete-orbital"},{"locale":"sl","path":"/sl/docs/tutorials/beginner/complete-orbital"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocTutorialsBeginnerCompleteOrbitalARDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocTutorialsBeginnerCompleteOrbitalARDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocTutorialsBeginnerCompleteOrbitalAROrbDocTutorialsBeginnerCompleteOrbitalARPage;
